import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-table-input',
    templateUrl: './table-input.component.html',
    styleUrls: [
        './table-input.component.scss'
    ]
})

export class TableinputComponent implements OnInit, OnChanges, OnDestroy {
    @Input() name: string = "";
    @Input() label: string = "";
    @Input() selectionTitle: string = "";
    @Input() form: FormGroup = null;
    @Input() columnList: {name: string, title?: string, label: string, type: string, optionList?: any[], min?: number, max?: number}[] = [];
    @Input() predefinedTable: any[][] = [];
    @Input() editingRowId: number = null;
    @Input() uniqueColumn: string = null;
    @Input() minimumRows: number = 0;
    @Input() requiredColumns: string[] = [];
    @Output() changeTableEvt: EventEmitter<any[][]> = new EventEmitter();
    @Output() changeForm: EventEmitter<any> = new EventEmitter();

    editingIndex: number = -1;
    validationMessage = '';

    table: any[][] = [];

    formRow: FormGroup;

    private subscriptions: Subscription[] = [];

    constructor(
        private fb: FormBuilder
    ) { }
    ngOnChanges(changes: SimpleChanges): void {
        console.log("CHANGES");;console.dir(changes)
        if(changes.predefinedTable){
            this.table = changes.predefinedTable.currentValue;
            console.log("new table: "); console.dir(this.table);
        }
        if (changes.editingRowId && changes.editingRowId.currentValue != null) {
            this.editRowById(changes.editingRowId.currentValue);
        }
    }

    ngOnInit() { 
        this.table = this.predefinedTable;
        // let formGroupOp = {};
        // this.columnList.forEach(col=>{
        //     formGroupOp[col.name] = [null]
        // });
        // console.log("formGroupOp: ");console.dir(formGroupOp)
        this.formRow = this.createFormRow();
        this.subscriptions.push(
            this.formRow.valueChanges.subscribe(values=>{
                this.changeForm.emit(this.formRow);
            })
        )
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub=>sub.unsubscribe());
    }

    createFormRow(){
        const formRow = new FormGroup({});

        formRow.addControl('id', new FormControl(null, []));

        this.columnList.forEach(col=>{
            formRow.addControl(col.name, new FormControl(null, []));
        });

        return formRow;
    }

    cleanFormRow(){
        this.columnList.forEach(col=>{
            console.log("column: ");console.dir(col);
            this.formRow.controls[col.name].patchValue(null)
        });
    }

    addRow(){
        this.validationMessage = '';
        const values = this.formRow.value;
        if (this.requiredColumns.some(column => values[column] === null || values[column] === undefined || values[column] === '')) {
            this.validationMessage = 'Completa los campos obligatorios antes de asignar.';
            return;
        }
        const invalidNumber = this.columnList.some(column => column.type === 'number' && values[column.name] !== null &&
            values[column.name] !== '' && column.min !== undefined && Number(values[column.name]) < Number(column.min));
        if (invalidNumber) {
            this.validationMessage = 'La cantidad debe ser igual o superior al mínimo permitido.';
            return;
        }
        if (this.uniqueColumn) {
            const formArray = this.form.controls[this.name] as FormArray;
            const duplicate = formArray.controls.some((control, index) =>
                index !== this.editingIndex && `${control.get(this.uniqueColumn).value}` === `${values[this.uniqueColumn]}`);
            if (duplicate) {
                this.validationMessage = 'El elemento seleccionado ya fue agregado.';
                return;
            }
        }
        if(this.editingIndex >= 0){
            this.saveRow();
            return;
        }

        this.table.push(
            this.columnList.map(col=>{
                const value = this.formRow.controls[col.name].value;

                if(col.type == 'list'){
                    const option = col.optionList.find(op => `${op.value}` == `${value}`);
                    if(option && option.text){
                        return option.text;
                    }
                }

                return value;
            })
        );

        this.changeTableEvt.emit(this.table);

        const lastFormRow = this.createFormRow();
        lastFormRow.patchValue(this.formRow.value);
        (this.form.controls[this.name] as FormArray).push(lastFormRow);

        this.cleanFormRow();
    }

    dropRow(row){
        this.validationMessage = '';
        if (this.table.length <= this.minimumRows) {
            this.validationMessage = 'Debe mantenerse al menos una fila.';
            return;
        }
        const index = this.table.indexOf(row);
        this.table.splice(index, 1);
        this.changeTableEvt.emit(this.table);
        (this.form.controls[this.name] as FormArray).removeAt(index);
    }

    editRow(row){
        const index = this.table.indexOf(row);
        if(index < 0) return;

        this.editingIndex = index;

        const formArray = this.form.controls[this.name] as FormArray;
        const currentFormRow = formArray.at(index) as FormGroup;

        if(currentFormRow){
            this.formRow.patchValue(currentFormRow.value);
        }
    }

    private editRowById(id: number) {
        if (!this.formRow || !this.form || !this.form.controls[this.name]) return;
        const formArray = this.form.controls[this.name] as FormArray;
        const index = formArray.controls.findIndex(control => `${control.get('id').value}` === `${id}`);
        if (index < 0) return;
        this.editingIndex = index;
        this.formRow.patchValue((formArray.at(index) as FormGroup).value);
    }

    cancelEdit(){
        this.editingIndex = -1;
        this.cleanFormRow();
    }

    saveRow(){
        if(this.editingIndex < 0) return;

        const displayRow = this.columnList.map(col=>{
            const value = this.formRow.controls[col.name].value;

            if(col.type == 'list'){
                const option = col.optionList.find(op => `${op.value}` == `${value}`);
                if(option && option.text){
                    return option.text;
                }
            }

            return value;
        });

        this.table[this.editingIndex] = displayRow;
        this.changeTableEvt.emit(this.table);

        const formArray = this.form.controls[this.name] as FormArray;
        const currentFormRow = formArray.at(this.editingIndex) as FormGroup;

        if(currentFormRow){
            currentFormRow.patchValue(this.formRow.value);
        }

        this.cancelEdit();
    }
}
